import styled from 'styled-components';

import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const FaqContainer = styled.div`
    > * {
        margin-bottom: 2em;
    }

    > *:last-child {
        margin-bottom: 10em;
    }
`;

export const SAccordion = styled(Accordion)`
    margin-bottom: 16px;
`;

export const AccordionContent = styled.div`
    display: block;

    a {
        ${FONTS.Medium}
        color: ${COLORS.Link};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }
`;
